<template>
    <div class="page">
        <!-- <div class="footer-block">
            <div class="col">
                <div class="footer-title">{{$t('message.findUsOn')}}</div>
                <div class="app-icon">
                    <Icon type="logo-twitter" color="white" size="20" />
                    <div class="app-name">Twitter</div>
                </div>
                <div class="app-icon">
                    <Icon type="logo-instagram" color="white" size="20" />
                    <div class="app-name">Instagram</div>
                </div>
                <div class="app-icon">
                    <Icon type="logo-facebook" color="white" size="20" />
                    <div class="app-name">Facebook</div>
                </div>
                <div class="app-icon">
                    <Icon type="logo-youtube" color="white" size="20" />
                    <div class="app-name">YouTube</div>
                </div>
            </div>
            <div class="line-bar"></div>
            <div class="col">
                <div class="footer-title">{{$t('message.contactUs')}}</div>
                <div class="app-icon">
                    <Icon type="ios-map-outline" color="white" size="20" />
                    <div class="app-name">{{$t('message.requestMap')}}</div>
                </div>
                <div class="app-icon">
                    <Icon type="md-help" color="white" size="20" />
                    <div class="app-name">{{$t('message.reportProblem')}}</div>
                </div>
            </div>
            <div class="line-bar"></div>
            <div class="col">
                <div class="footer-title">{{$t('message.help')}}</div>
                <div class="app-icon">
                    <div class="app-name">{{$t('message.faqs')}}</div>
                </div>
                <div class="app-icon">
                    <div class="app-name">{{$t('message.about')}}</div>
                </div>
                <div class="app-icon">
                    <div class="app-name">{{$t('message.terms')}}</div>
                </div>
                <div class="app-icon">
                    <div class="app-name">{{$t('message.privacy')}}</div>
                </div>
            </div>
        </div> -->

        <div class="footer">
            © 2020 StarLand Stays - STARLAND
        </div>
    </div>
</template>

<script>
  export default {
    name: "MyFooter"
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "myFooter.scss";
</style>
